export default __webpack_public_path__ + "static/media/landingVid.217bc138.mp4";